import Vue from 'vue';
import { gsap, Quad } from 'gsap';
import zenScroll from 'zenscroll';

Vue.component('map-component', {
    props: {
        allMapLocations: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            activeHoverItem: null,
            activeItem: null,
            groupedLocations: {},
            selectedMapItem: {},
            mapItemsById: {},
            search: '',
            // overlayIsOpen: false,
            infoBlockEl: null,
            infoBlockBox: null,
            infoBlockArrow: null
        }
    },

    watch: {
        // activeItem: function (val) {
        //     if(val !== null) {
        //         this.overlayIsOpen = true
        //         this.openAnimation()
        //     } else {
        //         this.closeAnimation()
        //         gsap.delayedCall(1, () => {
        //             this.overlayIsOpen = false
        //         });
        //         // Vue.nextTick(this.overlayIsOpen = false)
        //     }
        // }
    },

    mounted() {
        this.groupedLocations = _.groupBy(this.allMapLocations, "locationSection");
        this.infoBlockEl = document.querySelector('.map__legenda-holder');
        this.infoBlockBox = this.infoBlockEl.getBoundingClientRect();
        this.infoBlockArrow = document.querySelector('.map__legenda-arrow-holder');
        this.infoBlockArrowIcon = this.infoBlockArrow.querySelector('svg');

        const infoBlockArrowIconTl = gsap.timeline({ repeat: -1 });

        infoBlockArrowIconTl
            .to(this.infoBlockArrowIcon, {
                duration: 0.8,
                y: 5,
                ease: 'power2.inOut'
            })
            .to(this.infoBlockArrowIcon, {
                duration: 0.8,
                y: 0,
                ease: 'power2.inOut'
            }, '-=0.1');


        var items = _.groupBy(this.allMapLocations, "mapId")
        var result = {};
        Object.keys(items).forEach((key) => {
            result[key] = items[key];
        });

        this.mapItemsById = result
    },

    methods: {
        scrollToLegenda() {
            zenScroll.center(this.infoBlockEl, 500);
        },

        submitSearch() {
            // alert('fix this');
        },

        // openAnimation() {
        //     gsap.fromTo('.map__legenda-overlay-information-holder', {width: '0%'}, {width: '60%', duration: 1})
        //     gsap.fromTo('.map__legenda-overlay-information', {display: 'none', opacity: 0}, {display: 'block', opacity: 1, delay: 0.3, duration: 1})
        //     gsap.fromTo('.map__legenda-overlay-image', {width: '0%'}, {width: '40%', duration: 1})
        // },

        // closeAnimation() {
        //     gsap.fromTo('.map__legenda-overlay-information-holder', {width: '60%'}, {width: '0%', duration: 1, delay: 0.3})
        //     gsap.fromTo('.map__legenda-overlay-information', {display: 'block', opacity: 1}, {display: 'none', opacity: 0, duration: 0.3})
        //     gsap.fromTo('.map__legenda-overlay-image', {width: '40%'}, {width: '0%', duration: 1, delay: 0.3})
        // },

        onMapItemMouseEnter(event) {
            const target = event.currentTarget;

            if (this.activeHoverItem === target.id) {
                return;
            }

            if (this.mapItemsById[target.id]) {
                this.activeHoverItem = target.id;
            }

            this.onMapItemClick(event);
        },

        onMapItemMouseLeave(event) {
            this.activeHoverItem = null;
        },

        onMapLegendaItemClick(mapItem) {
            this.selectedMapItem = mapItem;
            const target = event.currentTarget;

            this.activeItem = target.dataset.mapItem;
            Vue.nextTick(this.positionPointer);

        },

        onMapItemClick(event) {
            const target = event.currentTarget;

            if (this.activeItem === target.id) {
                return;
            }

            if (this.mapItemsById[target.id]) {
                this.activeItem = target.id;
                this.selectedMapItem = this.mapItemsById[this.activeItem][0];
                Vue.nextTick(this.positionPointer);

                if (this.infoBlockEl && window.innerWidth < 768) {
                    zenScroll.toY(this.infoBlockBox.y - 300);
                } else if (this.infoBlockEl && window.innerWidth >= 768) {
                    gsap.to(this.infoBlockArrow, {
                        duration: 0.8,
                        ease: 'power4.out',
                        backgroundColor: target.dataset.color
                    });
                }
            }
        },

        positionPointer() {
            const element = document.getElementById(this.activeItem);
            const pointer = document.getElementById('map-pointer');
            const pointerCircle = document.getElementById('map-pointer-circle');
            const pointerLine = document.getElementById('map-pointer-line');
            const pointerFlag = document.getElementById('map-pointer-flag');
            const map = document.getElementById('svg-map');

            const rect = {
                x: (element.getBoundingClientRect().x - map.getBoundingClientRect().x) + (element.getBoundingClientRect().width / 2),
                y: (element.getBoundingClientRect().y - map.getBoundingClientRect().y) + (element.getBoundingClientRect().height / 2)
            }

            gsap.set(pointer, { x: rect.x, y: rect.y });
            gsap.set(pointerCircle, { scale: 0, transformOrigin: "center center" });
            gsap.set(pointerLine, { scaleY: 0, transformOrigin: "center bottom" });
            gsap.set(pointerFlag, { scaleX: 0, transformOrigin: "right top" });

            this.pointerTl = gsap.timeline({ paused: true });
            this.pointerTl.to(pointerCircle, { duration: .3, scale: 1, transformOrigin: "center center", ease: "power2.out" }, 0);
            this.pointerTl.to(pointerLine, { duration: .3, scaleY: 1, y: 0, transformOrigin: "center bottom", ease: "expo.out" }, 0.1);
            this.pointerTl.to(pointerFlag, { duration: .4, scaleX: 1, y: 0, transformOrigin: "right top", ease: "expo.out" }, 0.3);

            this.pointerTl.play();
        },

        toggleLegenda(event) {
            const legendaTitle = event.currentTarget.parentElement;
            const legendaContent = event.currentTarget.nextElementSibling;

            if (legendaTitle.classList.contains('active')) {
                legendaTitle.classList.remove('active');
                gsap.to(legendaContent, 0.3, {
                    height: 0,
                    ease: Quad.easeOut,
                });
            } else {
                legendaTitle.classList.add('active');
                gsap.to(legendaContent, 0.3, {
                    height: 'auto',
                    ease: Quad.easeOut,
                });
            }
        },
    }
});
